import React, { Component } from 'react'
import { BrowserRouter, HashRouter, Route, Switch } from 'react-router-dom'
import Editor from './pages/Editor'
import Home from './pages/Home/Home'
import Login from './pages/Login/Index'
import { SYSTEM_RUN_MODE } from './config/globals'
import authHOC from '@/core/auth'

import './App.css'

const routeConfig: any = {
  hash: HashRouter,
  browser: BrowserRouter,
}
let Router = BrowserRouter
if (routeConfig[SYSTEM_RUN_MODE.route]) {
  Router = routeConfig[SYSTEM_RUN_MODE.route]
}

function About() {
  return <h2>About</h2>
}

class App extends Component {
  render() {
    return (
      <div className="App">
        <Router
          children={
            <Switch>
              <Route path="/login" component={Login} />
              <Route path="/editor" component={Editor} />
              <Route path="/about" component={About} />
              <Route path="/" component={authHOC(Home)} />
            </Switch>
          }
        />
      </div>
    )
  }
}

export default App
